import React from 'react';
import PropTypes from 'prop-types';

import './Card.css';

const CardFooterC = (props) => {

  return (
    <div className={`card-footer ${props.className}`} automationid={`SalesLead_Div_${props.automationidattr}CardFooter_0`}>
      {props.children}
    </div>
  );
}

CardFooterC.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
}

export const CardFooter = CardFooterC;
